import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import AddProjects from './addProjects';
import Organization from '../../admin/organization';
import ProjectsInfo from './projectsInfo/';
export default {
  name: 'DefineProject',
  watch: {
    currentPage: function() {
      this.getProjectsList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getProjectsList();
    }
  },
  props: {
    showProjectComponent: Boolean
  },
  components: {
    AddProjects,
    Organization,
    ProjectsInfo
  },
  data() {
    return {
      unsubscribe: null,
      parent_value_set_id: null,
      showModalComponent: false,
      showValueSetModal: false,
      showDetails: false,
      orgType: null,
      openOuModal: false,
      payload: {},
      loader: false,
      editMode: false,
      showAlert: false,
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      tab: null,
      leName: {
        value: null,
        text: null
      },
      ouName: {
        value: null,
        text: null
      },
      location: {
        value: null,
        text: null
      },
      projType: {
        value: null,
        text: null
      },
      active: true,
      masterPrj: {
        value: null,
        text: null
      },
      defaultValue: {
        value: null,
        text: null
      },
      projectCode: null,
      projectName: null,
      parentProjectData: null,
      projectData: [],
      projectFields: [
        {
          key: 'project_code'
        },
        {
          key: 'project_name'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'ou_name',
          label: 'Operating Unit'
        },
        {
          key: 'location_name',
          label: 'Location'
        },
        {
          key: 'master_project_name'
        },
        {
          key: 'sector_name'
        },
        {
          key: 'pocket_name'
        },
        {
          key: 'project_type'
        },
        {
          key: 'start_date'
        },
        {
          key: 'end_date'
        },
        {
          key: 'active'
        },
        {
          key: 'version'
        }
      ]
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.hideModalComponent(true, 'AddProjects');
          this.parentProjectData = null;
        }
        if (
          actionName === 'download' &&
          !this.showModalComponent &&
          !this.showDetails
        ) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'projects/getProjectsProjectList',
            'prj-project',
            () => (this.loader = false)
          );
        }
      }
    });
    this.getProjectsList();
  },
  methods: {
    setChildName(tab) {
      //method for child modal name
      if (tab === 'AddProjects') {
        return (this.childName = 'Add Projects');
      } else if (tab === 'Organization') {
        return (this.childName = 'Organization');
      } else if (tab === 'ProjectsInfo') {
        return (this.childName = 'Projects Info');
      }
    },

    getProjectsList() {
      this.payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        project_name: this.projectName,
        project_code: this.projectCode,
        le_id: this.leName.value,
        ou_id: this.ouName.value,
        location_id: this.location.value,
        project_type: this.projType.value,
        active: this.active
      };
      this.loader = true;
      this.$store
        .dispatch('projects/getProjectsProjectList', this.payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.projectData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelected(rowData) {
      this.parentProjectData = rowData;
      this.$emit('projectDetails', this.parentProjectData);
      this.showDetails = true;
    },
    closeProjectDetail() {
      this.showDetails = false;
    },
    hideModalComponent(flag, component) {
      this.showModalComponent = flag;
      this.tab = component;
      this.setChildName(this.tab);
    },
    openCloseOu(flag, orgType, component) {
      this.tab = component;
      this.orgType = orgType;
      const dataToGetOrg = {
        orgType: orgType,
        parentLeId: null
      };
      this.$store.dispatch('shared/setUnsetOrgType', dataToGetOrg);
      this.setChildName(this.tab);
      this.showModalComponent = flag;
    },
    selectedOrg(item) {
      if (this.orgType === 'LE') {
        this.leName.value = item.org_id;
        this.leName.text = item.org_name;
      } else if (this.orgType === 'OU') {
        this.ouName.value = item.org_id;
        this.ouName.text = item.org_name;
      } else if (this.orgType === 'LOC') {
        this.location.value = item.org_id;
        this.location.text = item.org_name;
      }
      this.showModalComponent = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.leName = {
          value: item.org_id,
          text: item.org_name
        };
        this.ouName = this.defaultValue;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.ouName = {
          value: item.org_id,
          text: item.org_name
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LOCATION) {
        this.location = {
          value: item.loc_id,
          text: item.loc_name
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.PRJ_TYPE) {
        this.projType = {
          value: item.value_code,
          text: item.value_meaning
        };
      }
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      if (vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.parent_value_set_id = this.leName.value;
      }
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    updateProjectProjectList() {
      this.getProjectsList();
    },
    resetSearchFilters() {
      this.leName = this.defaultValue;
      this.ouName = this.defaultValue;
      this.location = this.defaultValue;
      this.projType = this.defaultValue;
      this.parent_value_set_id = null;
      this.projectCode = null;
      this.projectName = null;
      this.projectData = [];
      this.totalRows = null;
      this.currentPage = 1;
      if (!this.active) {
        this.active = true;
      }
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === this.leName.value) {
        this.leName = this.defaultValue;
        this.ouName = this.defaultValue;
      } else if (vsetCode === this.ouName.value) {
        this.ouName = this.defaultValue;
      } else if (vsetCode === this.location.value) {
        this.location = this.defaultValue;
      } else if (vsetCode === this.projType.value) {
        this.projType = this.defaultValue;
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
